import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import {
  QuestionsTemplatesNamespace,
  questionsTemplatesReducer,
} from './store/questions-templates.store';

@NgModule({
  imports: [StoreModule.forFeature(QuestionsTemplatesNamespace, questionsTemplatesReducer)],
})
export class QuestionsTemplatesDataModule {}
